module.exports = __webpack_public_path__ + "img/library.9ae3a3b8.svg";